import Bugsnag from '@bugsnag/js';
import DefaultLayout from 'components/layouts/DefaultLayout';
import NotFound from '../src/app/NotFound';

const ErrorPage = ({ statusCode }) => (
  <DefaultLayout path="/404" name="404" white searchBar>
    <NotFound statusCode={statusCode} />
  </DefaultLayout>
);

ErrorPage.getInitialProps = (props: any = {}) => {
  const { res, err, req } = props;

  const getStatusCode = () => {
    if (res) {
      return res.statusCode;
    }
    if (err) {
      return err.statusCode;
    }
    return 404;
  };

  const statusCode = getStatusCode();
  const error = err || new Error('Unknown error caught by ErrorPage.getInitialProps');

  // Ignore 404 errors
  if (statusCode === 404) {
    return { statusCode };
  }

  Bugsnag.notify(error, (event) => {
    event.addMetadata('SSR', {
      asPath: props?.asPath,
      req,
    });
  });

  return { statusCode };
};

export default ErrorPage;
